import { useCallback } from "react";
import { useFieldActions } from "../../contexts/field-actions-context.js";
const useUploadSignature = (uploadTarget) => {
  const { actions, formId } = useFieldActions();
  const uploadFile = actions?.uploadFile;
  return useCallback(
    async (file) => {
      if (!uploadFile) {
        throw new Error("No uploadFile action");
      }
      const fileDescriptor = await uploadFile({
        file,
        formId,
        uploadTarget
      });
      const { id, displayName, url, isPrivate } = fileDescriptor;
      return {
        fileId: id,
        displayName: displayName || file.name,
        url: !isPrivate ? url : void 0,
        fileType: file.type
      };
    },
    [uploadFile, formId, uploadTarget]
  );
};
export {
  useUploadSignature
};
//# sourceMappingURL=use-upload-signature.js.map
